export const getProductsInCart = (state) => state.cart.data;

export const cartLoading = (state) => state.cart.isLoading;
  